import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const JewelryRepair = () => {
  return (
    <Container className="mt-4">
      <img
        src={require("../../../Front/themes/showcase/assets/images/services/services-banner1.jpg")}
        alt="certificate"
        className="img-fluid border p-1"
      />
      <h2 className="font-weight-bold mt-5 mb-3 text-center">Jewelry Repair</h2>
      <p>
        Fine jewelry is prone to wear, so always have your fine jewelry checked
        by a jeweler every year. If you are considering getting your ring or
        bracelet repaired, trust in the skills of your jewelers. Some jewelry
        shops train jewelry craftsmen to carry out in-house repairs, while some
        offer custom-made design work. If you have not yet come into contact
        with a trusted jeweler, you can come To Khan Diamonds.
      </p>
      <Row className="align-items-center mb-4">
        <Col md={6}>
          <img
            src={require("../../../Front/themes/showcase/assets/images/services/repair.jpg")}
            alt="certificate"
            className="img-fluid border p-1"
          />
        </Col>
        <Col md={6}>
          <h3 className="font-weight-bold text-center">
            WE OFFER SAME DAY REPAIRING SERVICES, WHILE YOU WAIT AND WATCH
          </h3>
        </Col>
      </Row>
      <h2 className="font-weight-bold mt-4 mb-4">Our jewelry repair services include, but are not limited to</h2>
      <Row>
        <Col md={3}>
          <h5 className="font-weight-bold mb-3">Ring Sizing</h5>
          <p>
            If the ring you got doesn’t fit you well, you can get it to us. Our
            in-house expert professionals will properly size the ring to make
            sure that it fits properly so that you can enjoy wearing it.
          </p>
        </Col>
        <Col md={3}>
          <h5 className="font-weight-bold mb-3">Custom Engraving</h5>
          <p>
            One of the best ways to make a gift even meaningful is by getting an
            intimate message or a special date custom engraved on it. We will
            gladly do it for you to make your gift memorable.
          </p>
        </Col>
        <Col md={3}>
          <h5 className="font-weight-bold mb-3">Stone Replacement</h5>
          <p>
            Lost a precious stone in your jewelry? Don't worry! At Khan
            Diamonds, we will find a suitable location for a lost gem and place
            it in jewelry to make it look as beautiful as new.
          </p>
        </Col>
        <Col md={3}>
          <h5 className="font-weight-bold mb-3">Remounting</h5>
          <p>
            Want to get a new look for your precious jewelry or lose the jewel
            of your jewelry? Just choose the stone of your choice and our
            experts will carefully remind you of your jewelry to make it look
            new again.
          </p>
        </Col>
        <Col md={3}>
          <h5 className="font-weight-bold mb-3">Clasps Replacement</h5>
          <p>
            A broken clasp leaves your jewelry unprotected and is likely to get
            lost. At Khan Diamonds, we will replace the broken clasp with a new
            one to make your jewelry secure again.{" "}
          </p>
        </Col>
        <Col md={3}>
          <h5 className="font-weight-bold mb-3">Bracelet Repair</h5>
          <p>
            Can't wear your favorite bracelet because it's broken or damaged?
            Bring it to us, and we will prepare it for you. Our technicians will
            repair it and replace the broken parts so you can put it on again.{" "}
          </p>
        </Col>
        <Col md={3}>
          <h5 className="font-weight-bold mb-3">Chain Repairs</h5>
          <p>
            Want to put on your broken chain again? Bring to Khan Diamonds! We
            have jewelry repair specialists who will inspect your series to find
            damaged or broken parts and repair them properly.
          </p>
        </Col>
        <Col md={3}>
          <h5 className="font-weight-bold mb-3">Watch Repairs And Bands</h5>
          <p>
            At Khan Diamonds, we not only fix jewelry, but we also look at
            watches. Whether it’s broken glass, damaged travel parts or worn-out
            belts, we’ll take care of them all so you can put on your beloved
            watch again.
          </p>
        </Col>
        <Col md={3}>
          <h5 className="font-weight-bold mb-3">Pearl Stringing</h5>
          <p>
            Regular wearing of pearl jewelry can make the strings loose not only
            prevent the beauty of the jewelry but also cause the pearls to
            scratch each other's faces and ultimately damage them. At Khan
            Diamonds, we offer excellent pearl retrieval services to make your
            pearl jewelry look beautiful again
          </p>
        </Col>
        <Col md={3}>
          <h5 className="font-weight-bold mb-3">Retipping Prongs</h5>
          <p>
            Fabric fabrics can wear out for a long time leaving the gemstone
            less secure and you can lose the gemstone. That’s why we recommend
            our customers to have their prongs tested and re-delivered from time
            to time. Our experts will also give you a prong to make sure your
            gemstone is safe as well.
          </p>
        </Col>
      </Row>

      <p>
        For all your jewelry repair needs, please feel free to visit our store
        or{" "}
        <a href="/contact" className="text-dark">
          <b>Contact Us</b>
        </a>
      </p>
    </Container>
  );
};

export default JewelryRepair;
